import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IBankAccount } from 'src/app/pages/core/models/User';

@Component({
  selector: 'app-account-search-bar',
  templateUrl: './account-search-bar.component.html',
  styleUrls: ['./account-search-bar.component.scss'],
})
export class AccountSearchBarComponent implements OnInit {
  @Output() searchChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() fiatAccounts: IBankAccount[] = [];
  @Input() cryptoAccounts: any[] = [];
  public searchValue = new FormControl('', []);
  private results: any = {
    fiatAccounts: [],
    cryptoAccounts: [],
    query: '',
  };

  constructor() {}

  ngOnInit(): void {}

  handlerChangeSearch(): void {
    const searchValue = this.searchValue.value.toLowerCase();
    this.results.query = searchValue;
    if (searchValue.length > 0) {
      this.results.fiatAccounts = this.fiatAccounts.filter((account) => {
        return (
          account.description?.toLowerCase().includes(searchValue) ||
          account.cbu?.toLowerCase().includes(searchValue)
        );
      });
      this.results.cryptoAccounts = this.cryptoAccounts.filter((account) => {
        return (
          account.address?.toLowerCase().includes(searchValue) ||
          account.description?.toLowerCase().includes(searchValue)
        );
      });
    } else {
      this.results.fiatAccounts = this.fiatAccounts;
      this.results.cryptoAccounts = this.cryptoAccounts;
    }
    this.searchChange.emit(this.results);
  }

  clearSearch(): void {
    this.searchValue.setValue('');
    this.results.fiatAccounts = this.fiatAccounts;
    this.results.cryptoAccounts = this.cryptoAccounts;
    this.results.query = '';
    this.searchChange.emit(this.results);
  }
}
